type Status =
  | 'success' | 'failed' | 'running' | 'warning'
  | 'on-track' | 'at-risk'
  | 'active' | 'renewal-due' | 'expired'
  | 'in-progress' | 'blocked' | 'todo' | 'done'
  | (string & {})

interface StatusConfig {
  label: string
  cls: string
  dot: string
  dotColor?: string
}

const STATUS_MAP: Record<string, StatusConfig> = {
  success:      { label: 'Success',     cls: 'badge-ok',   dot: 'dot-ok' },
  failed:       { label: 'Failed',      cls: 'badge-err',  dot: 'dot-err' },
  running:      { label: 'Running',     cls: 'badge-info', dot: 'dot-pulse', dotColor: 'var(--ns-info)' },
  warning:      { label: 'Warning',     cls: 'badge-warn', dot: 'dot-warn' },
  'on-track':   { label: 'On track',    cls: 'badge-ok',   dot: 'dot-ok' },
  'at-risk':    { label: 'At risk',     cls: 'badge-warn', dot: 'dot-warn' },
  active:       { label: 'Active',      cls: 'badge-ok',   dot: 'dot-ok' },
  'renewal-due':{ label: 'Renewal due', cls: 'badge-warn', dot: 'dot-warn' },
  expired:      { label: 'Expired',     cls: 'badge-err',  dot: 'dot-err' },
  'in-progress':{ label: 'In progress', cls: 'badge-info', dot: 'dot-pulse', dotColor: 'var(--ns-info)' },
  blocked:      { label: 'Blocked',     cls: 'badge-err',  dot: 'dot-err' },
  todo:         { label: 'To do',       cls: '',           dot: 'dot-muted' },
  done:         { label: 'Done',        cls: 'badge-ok',   dot: 'dot-ok' },
  certified:    { label: 'Certified',   cls: 'badge-ok',   dot: 'dot-ok' },
}

interface StatusBadgeProps {
  status: Status
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const m = STATUS_MAP[status] ?? { label: status, cls: '', dot: 'dot-muted' }
  return (
    <span className={`badge ${m.cls}`}>
      <span
        className={`dot ${m.dot}`}
        style={m.dotColor ? { background: m.dotColor } : undefined}
      />
      {m.label}
    </span>
  )
}
